// extracted by css-extract-rspack-plugin
export default {"container":"container-ZSLGqv","textGroup":"textGroup-HW6Lp6","textGroupTop":"textGroupTop-EHd7aR","textGroupBottom":"textGroupBottom-GTUgdE"};